<script setup lang="ts">
import type { KjdsDetailPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsDetailPageProps>(), {})

const app = useNuxtApp()
const route = useRoute()
const storeIndex = useStoreIndex()

const baseTitle = 'レポート'
let headTitle = ''
let headDescription = ''

const refData = reactive({ aTag: null })

const setHead = () => {
  const articleTitle = props.kjdsDetailData.article.title
  headTitle = `${articleTitle} | ${baseTitle}`
  headDescription = `${articleTitle}の取材レポート。${articleTitle}を実際の会場で取材し、写真と動画で紹介。行ったからこそ分かる${articleTitle}の見どころとポイントを分かりやすくお伝えします。${articleTitle}のレビューはアイエムで！`
  if (props.kjdsDetailData.article.description?.length) {
    headDescription = props.kjdsDetailData.article.description
  }
  // ぱんくず作成
  if (route.query.fromname === 'foryou') {
    storeIndex.setBreadCrumbs([
      {
        text: 'For You',
        disabled: false,
        to: {
          name: 'mypage-foryou-tab',
          params: { tab: 'report' },
        },
      },
      {
        text: articleTitle,
        disabled: true,
      },
    ])
  } else {
    storeIndex.setBreadCrumbs([
      {
        text: baseTitle,
        disabled: false,
        to: { path: '/report' },
      },
      {
        text: articleTitle,
        disabled: true,
      },
    ])
  }

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
    ogImage: props.kjdsDetailData.eyeCatch?.url ? props.kjdsDetailData.eyeCatch.url : undefined,
  })
  useHead(headInput)
}

// イベントから表示カラム作成
if (!refData.aTag) {
  refData.aTag = app.$getArticleTags(props.kjdsDetailData.article)
} // タグリスト

setHead()
</script>

<template>
  <div class="p-articleDetailPage">
    <div>
      <ReportAreaBody
        v-if="props.kjdsDetailData.article.custom.is_im_report === '0'"
        v-bind:item="props.kjdsDetailData.article"
        v-bind:objects="props.kjdsDetailData.objects"
      />
      <ReportImBody
        v-else-if="props.kjdsDetailData.article.custom.is_im_report === '1'"
        v-bind:title="headTitle"
        v-bind:item="props.kjdsDetailData.article"
        v-bind:objects="props.kjdsDetailData.objects"
      />

      <ArticleTagList
        v-if="refData.aTag.length > 0"
        v-bind:article-name="props.kjdsDetailData.article.article_type_slug"
        v-bind:items="refData.aTag"
        class="pc-only"
      />

      <RelationBox
        article="present"
        v-bind:header="'関連するプレゼント'"
        v-bind:relations="props.kjdsDetailData.article.relations"
      />
      <RelationBox
        article="jyunkai"
        v-bind:header="'関連する巡回展'"
        v-bind:relations="props.kjdsDetailData.article.relations"
      />
      <RelationBox
        article="special"
        v-bind:header="'関連する特集'"
        v-bind:relations="props.kjdsDetailData.article.relations"
      />

      <ArticleTagList
        v-if="refData.aTag.length > 0"
        v-bind:article-name="props.kjdsDetailData.article.article_type_slug"
        v-bind:items="refData.aTag"
        class="sp-only"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";
</style>
